var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDsGraphicsIcon = function SvgDsGraphicsIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M10.12 3.333a2.12 2.12 0 1 0 0 4.24 2.12 2.12 0 0 0 0-4.24m-.787 2.12a.787.787 0 1 1 1.574 0 .787.787 0 0 1-1.574 0",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M.667 2.667a2 2 0 0 1 2-2h10.666a2 2 0 0 1 2 2v10.666a2 2 0 0 1-2 2H2.667a2 2 0 0 1-2-2zM2 13.333v-1.406l3.334-3.611 2.798 3.025c.406.44 1.086.484 1.546.1l1.989-1.657 2.323 1.936.01.009v1.604a.667.667 0 0 1-.667.667H2.667A.667.667 0 0 1 2 13.333M14 2.667v7.326L12.387 8.65a1.125 1.125 0 0 0-1.44 0l-1.97 1.642L6.16 7.245a1.125 1.125 0 0 0-1.653 0L2 9.963V2.667C2 2.298 2.299 2 2.667 2h10.666c.368 0 .667.298.667.667",
    clipRule: "evenodd"
  })));
};
export default SvgDsGraphicsIcon;